"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _formik = require("formik");

var _Input = _interopRequireDefault(require("elevate-ui/Input"));

var _NumberIncrement = _interopRequireDefault(require("elevate-ui/NumberIncrement"));

var _ColorPicker = _interopRequireDefault(require("elevate-ui/ColorPicker"));

var _Select = _interopRequireDefault(require("elevate-ui/Select"));

var _Padding = _interopRequireDefault(require("../../Common/Padding"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var fontFamilies = [{
  label: "Arial",
  value: "Arial, Helvetica, sans-serif"
}, {
  label: "Arial Black",
  value: "‘Arial Black’, Gadget, sans-serif"
}, {
  label: "Bookman Old Style",
  value: "‘Bookman Old Style’, serif"
}, {
  label: "Comic Sans MS",
  value: "‘Comic Sans MS’, cursive"
}, {
  label: "Courier",
  value: "Courier, monospace"
}, {
  label: "Courier New",
  value: "‘Courier New’, Courier, monospace"
}, {
  label: "Garamond",
  value: "Garamond, serif"
}, {
  label: "Georgia",
  value: "Georgia, serif"
}, {
  label: "Impact",
  value: "Impact, Charcoal, sans-serif"
}, {
  label: "Lucida Console",
  value: "‘Lucida Console’, Monaco, monospace"
}, {
  label: "Lucida Sans Unicode",
  value: "‘Lucida Sans Unicode’, ‘Lucida Grande’, sans-serif"
}, {
  label: "MS Sans Serif",
  value: "‘MS Sans Serif’, Geneva, sans-serif;"
}, {
  label: "‘MS Serif’",
  value: "‘MS Serif’, ‘New York’, sans-serif;"
}, {
  label: "Palatino Linotype",
  value: "‘Palatino Linotype’, ‘Book Antiqua’, Palatino, serif;"
}, {
  label: "Symbol",
  value: "Symbol, sans-serif"
}, {
  label: "Tahoma",
  value: "Tahoma, Geneva, sans-serif"
}, {
  label: "Times New Roman",
  value: "‘Times New Roman’, Times, serif"
}, {
  label: "Trebuchet MS",
  value: "‘Trebuchet MS’, Helvetica, sans-serif"
}, {
  label: "Verdana",
  value: "Verdana, Geneva, sans-serif"
}];
/*
Yup.object().shape({
  children: Yup.string().required(),
  url: Yup.string().required(),
  fontSize: Yup.number(),
  color: Yup.string().required(),
  textColor: Yup.string().required(),
  buttonPaddingTop: Yup.number(),
  buttonPaddingRight: Yup.number(),
  buttonPaddingBottom: Yup.number(),
  buttonPaddingLeft: Yup.number(),
})
*/

var ButtonForm = function ButtonForm(props) {
  return /*#__PURE__*/_react["default"].createElement(_react.Fragment, null, /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "children",
    name: "children",
    label: "Button Text",
    component: _Input["default"],
    type: "text"
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "url",
    name: "url",
    label: "URL",
    component: _Input["default"],
    type: "text"
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "fontFamily",
    name: "fontFamily",
    label: "Font Family",
    component: _Select["default"],
    items: fontFamilies
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "fontSize",
    name: "fontSize",
    label: "Font Size",
    component: _Input["default"],
    type: "number"
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "backgroundColor",
    name: "backgroundColor",
    label: "Button Color",
    component: _ColorPicker["default"]
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "color",
    name: "color",
    label: "Text Color",
    component: _ColorPicker["default"]
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "borderSize",
    name: "borderSize",
    label: "Border Size",
    component: _NumberIncrement["default"],
    min: "0"
  }), /*#__PURE__*/_react["default"].createElement(_formik.FastField, {
    id: "borderColor",
    name: "borderColor",
    label: "Border Color",
    component: _ColorPicker["default"]
  }), /*#__PURE__*/_react["default"].createElement(_Padding["default"], null));
};

var _default = ButtonForm;
exports["default"] = _default;